import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { faMinusCircle } from '@fortawesome/pro-solid-svg-icons';

import SidebarSearch from 'components/search_sidebar/sidebar_search';

import Users from './users';

export default function SelectedUsers({
  selectedUserIds,
  users: allUsers,
  onChange
}) {
  const selectedUsers = () => {
    return allUsers.filter(user => selectedUserIds.indexOf(user.id) !== -1);
  };

  const [searchText, setSearchText] = useState('');
  const [users, setUsers] = useState(selectedUsers());

  React.useEffect(() => {
    setUsers(selectedUsers());
  }, [selectedUserIds]);

  const handleRemove = (user) => {
    const userIds = selectedUserIds.filter(selectedUserId => selectedUserId !== user.id);
    onChange(userIds);
  };

  const handleClear = () => {
    onChange([]);
  };

  const filteredUsers = () => {
    return users.filter((user) => {
      return !searchText || user.name.toLowerCase().includes(searchText.toLowerCase());
    });
  };

  return (
    <div className="selected-users panel panel-default">
      <div className="panel-heading">
        <div className="search-bar">
          <SidebarSearch
            placeholder="Search by name"
            value={searchText}
            onChange={({ target: { value } }) => setSearchText(value)}
          />
        </div>
        <a className="pull-right" name="clear" onClick={handleClear}>Remove All</a>
      </div>

      <Users
        controlIcon={faMinusCircle}
        emptyMessage="No users selected"
        users={filteredUsers()}
        onSelect={handleRemove}
      />
    </div>
  );
}

SelectedUsers.propTypes = {
  selectedUserIds: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,

  onChange: PropTypes.func.isRequired
};
